import styled from "styled-components";

export const BookingStep2FormStyled = styled.div`
  .section {
    .f_title {
      margin-left: 16px;
      margin-bottom: 20px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      white-space: pre-wrap;
    }
    .calendar_layout {
      margin-bottom: 20px;
      padding: 0 50px;
    }
    .input_wrap {
      margin-bottom: 20px;
      padding: 0 50px;
      &.mb_70 {
        margin-bottom: 70px;
      }
      &.ml_50 {
        margin-left: 25px;
      }
    }
    .f_action_row {
      padding: 0 42px;
      display: flex;
      column-gap: 36px;
      .btn_wrap {
        flex: 1;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .section {
      .calendar_layout {
        padding: 0px;
      }
      .input_wrap {
        padding: 0px;
      }
      .f_action_row {
        padding: 0px;
        column-gap: 16px;
      }
    }
  }
`;
